export const EMPLOYEE_SEARCH_LIMIT = 100;
export const EMPLOYEE_SEARCH_ORDER_ASC = 'firstName';
